let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("29P6Z")).then(() => parcelRequire('4awuM'));